"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/overlay/examples/index.ts';
var OverlayExample = /** @class */ (function () {
    function OverlayExample() {
        this.closeOnEscapeKey = true;
        this.closeOnOutsideClick = true;
        this.inline = false;
        this.hasBackdrop = true;
        this.isOpen = false;
    }
    OverlayExample.prototype.view = function () {
        var _this = this;
        var style = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100
        };
        var cardStyles = {
            margin: '40px auto'
        };
        var content = (0, mithril_1.default)('', { style: style }, [
            (0, mithril_1.default)(_1.Card, { style: cardStyles }, [
                (0, mithril_1.default)('h3', 'Title'),
                (0, mithril_1.default)(_1.Button, {
                    label: 'Close',
                    onclick: function () { return _this.isOpen = false; }
                })
            ])
        ]);
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Button, {
                label: 'Show Overlay',
                intent: 'primary',
                onclick: function () { return _this.isOpen = true; }
            }),
            (0, mithril_1.default)(_1.Overlay, {
                closeOnEscapeKey: this.closeOnEscapeKey,
                closeOnOutsideClick: this.closeOnOutsideClick,
                hasBackdrop: this.hasBackdrop,
                inline: this.inline,
                content: content,
                isOpen: this.isOpen,
                onClose: function () { return _this.isOpen = false; },
                transitionDuration: 0
            })
        ]);
    };
    OverlayExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)(_1.Switch, {
                checked: this.closeOnEscapeKey,
                label: 'Close on ESC key',
                onchange: function () { return _this.closeOnEscapeKey = !_this.closeOnEscapeKey; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.closeOnOutsideClick,
                label: 'Close on outside click',
                onchange: function () { return _this.closeOnOutsideClick = !_this.closeOnOutsideClick; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.inline,
                label: 'Render inline',
                onchange: function () { return _this.inline = !_this.inline; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.hasBackdrop,
                label: 'Has backdrop',
                onchange: function () { return _this.hasBackdrop = !_this.hasBackdrop; }
            })
        ];
    };
    return OverlayExample;
}());
exports.OverlayExample = OverlayExample;
